<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc1"><a href="#/chapter01">1. Bayonne, December 18, 1958</a></p>
<p class="toc"><a href="#/chapter02">2. “Have Gun—Am Traveling”</a></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Getaway</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. “I Don’t Know How We Didn’t Get Killed”</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. A Troubled Youth</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Life in Prison</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. The Light Becomes Brighter</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Cold Case</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. Anna Marie Olesiewicz</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Key Witness</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. The Takedown</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Long Night</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. Dead-Ends</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. Guns, Drugs and Killings</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">15. “Perverted, Sick Individuals”</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">16. “It’s a Chop Job”</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">17. “It Was a Terrible Thing”</span></p>
<p class="toc"><span href="#/chapter18" title="Link target outside of Sample">18. “All This Guy Had on His Mind Was Killing, Killing, Killing”</span></p>
<p class="toc"><span href="#/chapter19" title="Link target outside of Sample">19. “He Already Tried the Case in the Newspaper”</span></p>
<p class="toc"><span href="#/chapter20" title="Link target outside of Sample">20. Questions but No Answers</span></p>
<p class="toc1"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?600edad6